<template>
  <div padding>
    <annot8-ui ref="ui" :state="state"></annot8-ui>
    <div
      class="article-content allow-select"
      ref="root"
      v-html="sanitizedContent"
      :style="style"
      @click="onClick"
    ></div>

    <annot8-canvas
      ref="canvas"
      :state="state"
      :highlights="state.highlights"
    ></annot8-canvas>
  </div>
</template>
<script>
import debounce from "debounce";
import EventSpy from "./EventSpy";
import { toRange, fromRange } from "xpath-range";
import Annot8UI from "./Annot8UI";
import Annot8Canvas from "./Annot8Canvas";
import RangeSniffer from "./RangeSniffer";

export default {
  data() {
    return {
      timeoutId: null,
      saveIntervalId: null,
      uploadLoginMessageShown: false,
      requestUpload: false,
      root: null,
      state: {
        digest: "",
        annotations: [],
        highlights: [],
        selection: null,
        range: null,
        selectionBounds: { rect: {}, ready: false },
        canvas: {},
        offset: null,
        root: null,

        // ui
        focus: null,
        menu: null,
        subMenu: null,
        tag: "facts"
      }
    };
  },

  props: {
    docId: [Number, String],
    docType: String,
    content: String
  },

  computed: {
    style() {
      return {
        position: "relative",
        "z-index": 1
      };
    },
    sanitizedContent() {
      var str = this.content;
      return str;
      return str.replace(/.*?(?=<center)/s, "");
    }
  },

  methods: {
    attachEventSpy() {
      this.root = this.$refs.root;

      //------------------
      // fire up events
      //------------------
      EventSpy.start(
        this.root,
        /* selection callback */
        (sel, range) => {
          if (!sel) return;
          if (this.state.subMenu == "comments") {
            this.setState({ subMenu: null });
          }
          this.setState({ selectionBounds: { ready: false } });
          this.onSelectionChanged(sel, range);
        },
        /* resize callback */
        () => {
          if(this.state.subMenu != "comments") {
            this.setState({ menu: null, subMenu: null });
          }
          this.onDocumentResized();
        },
        /* mouse callback */
        (pos, src) => {
          this.setState({ menu: null, subMenu: null });
          this.setState({ selectionBounds: { ready: false } });
          this.onMouseUp(pos);
        },
        /* key callback */
        keycode => {
          var params = {};
          if (this.annotation()) {
            params.id = this.annotation().id;
          }

          var hasPopover = document.querySelectorAll("ion-popover");
          if(hasPopover.length > 0) {
            return;
          }

          switch (keycode) {
            case 49: // 1
            case 50: // 2
            case 51: // 3
            case 52: // 4
              if (this.state.subMenu !== "comments") {
                let tag = "facts";
                let tagid = 1;
                if((keycode - 48) == 2) {
                  tag = "issues";
                  tagid = 2;
                }
                if((keycode - 48) == 3) {
                  tag = "ruling";
                  tagid = 3;
                }
                if((keycode - 48) == 4) {
                  tag = "principles";
                  tagid = 4;
                }
                params.tag = tag;
                params.tagid = tagid;
                this.annotate(params);
              }
              break;
            case 9: // tab
              if (!this.state.focus) {
                return;
              }
              this.state.menu = "edit";
              this.state.subMenu = "comments";
              break;
            case 13: // enter
              if (this.state.subMenu !== "comments") {
                this.annotate({});
              }
              break;
            case 46:
            case 8: // backspace
              if (
                this.state.focus == null ||
                this.state.subMenu == "comments"
              ) {
                return;
              }
              this.erase(this.state.focus);
              break;
            case 27: // escape
              this.setState({ tag: "", menu: null, subMenu: null });
              this.clearSelection();
              break;
          }
        }
      );
    },

    setState(state) {
      Object.keys(state).forEach(k => {
        this.state[k] = state[k];
      });
    },

    loadData(data) {
      let annotations = [];
      (data || []).forEach(a => {
        annotations.push(Object.assign(a, { rects: [] }));
      });

      this._reindex(annotations);
      this.setState({ annotations: annotations });

      this.draw();
      this.clearSelection();
    },

    async onRead() {
      var doc = this.$store.state.annotation["case-" + this.docId];
      if (doc) {
        this._reindex(doc.annotations);
        this.state.annotations = doc.annotations;
      }

      if (this.checkLogin()) {
        var res = await this.$lawyerly.annotations.search({
          user: this.$store.state.user.user.email,
          docId: this.docId,
          typeId: this.docType == 'case' ? 1 : 2
        });

        if(res){
          if(res.data) {
            if(res.data.length == 0) {
              this.state.annotations = [];
              this._saveAnnotationsToLocal();
              return;
            }
          }
        }

        if (
          res &&
          res.data &&
          typeof res.data === "object" &&
          res.data.length > 0
        ) {
          var annots = [];
          res.data.forEach(a => {
            annots.push({
              quote: a.quote,
              range: a.ranges,
              tag: a.tags,
              tagid: a.tagid,
              y: a.y,
              comment: a.text,
              oid: a.id
            });
          });
          this._reindex(annots);
          this.state.annotations = annots;
          this._saveAnnotationsToLocal();
        }
      }

      // check from server
      this.onDocumentResized();
    },

    async onCreate(annotation) {
      if (!this.checkLogin()) {
        this.$store.commit("ui/setSpinner", false);
        return;
      }

      await this.$lawyerly.annotations.create(
        this._saveAnnotationData(annotation)
      ).then(res => {
        if (res.data.error) {
        this.$ionic.showToast(res.data.error, {
          position: "top",
          duration: 3500
        });
        return;
        }

        if (res.data) {
          this.$set(annotation, "oid", res.data.id);
          this._saveAnnotationsToLocal();
          return;
        }
      }).catch(err => {
        
          this.$ionic.showToast( "Something went wrong! Unable to save annotation.", {
            position: "top"
          });
      });

      this.$store.commit("ui/setSpinner", false);
    },

    async onUpdate(annotation) {
      if (!this.checkLogin()) {
        this.$store.commit("ui/setSpinner", false);
        return;
      }
      if (!annotation.oid) {
        return;
      }
      
      await this.$lawyerly.annotations.update(
        this._saveAnnotationData(annotation)
      ).then(res => {
        this._saveAnnotationsToLocal();
        this.setState({ menu: null, subMenu: null });
      }).catch(err => {
        this.$ionic.showToast( "Something went wrong! Unable to save annotation.", {
          position: "top"
        });
      });
      
      this.$store.commit("ui/setSpinner", false);
    },

    async onDelete(annotation) {
      if (!this.checkLogin()) {
        return;
      }

      if(!annotation) {
        return;
      }

      if(annotation == "all") {
        var res = await this.$lawyerly.annotations.clear(
          this._saveAnnotationData(annotation)
        );
        this._saveAnnotationsToLocal();
        return;
      }

      if (!annotation.oid) {
        return;
      }
      var res = await this.$lawyerly.annotations.delete(
        this._saveAnnotationData(annotation)
      );
      this._saveAnnotationsToLocal();
    },

    _saveAnnotationData(annotation) {
      return {
        user: this.$store.state.user.user.email,
        docId: this.docId,
        docType: this.docType,
        typeId: this.docType == 'case' ? 1 : 2,
        annotation: annotation
      };
    },

    _saveData() {
      return {
        id: `${this.docType}-` + this.docId,
        docId: this.docId,
        docType: this.docType,
        annotations: this.state.annotations,
        digest: this.state.digest
      };
    },

    _saveAnnotationsToLocal() {
      this.$store.commit("annotation/save", this._saveData());
    },

    checkLogin() {
      if (!this.$store.state.user.user || !this.$store.state.user.user.email) {
        if (!this.uploadLoginMessageShown) {
          this.$ionic.showToast(
            "You are not logged in. Annotations are ephemeral.",
            {
              showCloseButton: true,
              duration: 5000,
              position: "top"
            }
          );
        }
        this.uploadLoginMessageShown = true;
        return false;
      }
      return true;
    },

    upload() {
      // if (!this.$store.state.user.user || !this.$store.state.user.user.email) {
      //   if (!this.uploadLoginMessageShown) {
      //     this.$ionic.showToast(
      //       "You are not logged in. Annotations are ephemeral.",
      //       {
      //         showCloseButton: true,
      //         duration: 5000,
      //         position: "top"
      //       }
      //     );
      //   }
      //   this.uploadLoginMessageShown = true;
      //   return;
      // }
      // const data = this._saveData();
      // data.user = this.$store.state.user.user.email;
      // return this.$lawyerly.annotations.save(data);
    },

    onSelectionChanged: debounce(function(sel, range) {

      // fix range on line breaks
      const normalized = RangeSniffer.normalize(range);

      this.setState({ selection: sel });
      this.setState({ rawRange: range });
      this.setState({ range: range ? fromRange(normalized, this.$refs.root) : null });
      this.setState({ selectionBounds: { ready: false } });
      this.calculateSelectionBounds(range);
      if (range) {
        this.setState({ focus: null });
        this.setState({ menu: "create" });
      }
    }, 150),

    onDocumentResized: debounce(function() {
      this.setState({ offset: null });
      this.draw();
    }, 150),

    onMouseUp: debounce(function(pos) {
      this.setState({ focus: null });

      var pad = 4;
      // make relative
      pos.x = pos.x - window.scrollX;
      pos.y = pos.y - window.scrollY;

      // console.log(pos);

      // get hit highlight
      var rects = [];
      document.querySelectorAll(".annot8-hl").forEach(n => {
        var h = n.getClientRects()[0];
        h.x = h.x || h.left;
        h.y = h.y || h.top;
        var left = h.x - pad;
        var right = h.x + h.width + pad;
        var top = h.y - pad;
        var bottom = h.y + h.height + pad;

        // console.log(left + ',' + top + ',' + right + ',' + bottom)

        if (left < pos.x && right > pos.x && top < pos.y && bottom > pos.y) {
          this.setState({ focus: parseInt(n.dataset.id) });
          rects.push({ x: pos.x, y: h.y, width: 2, height: h.bottom - h.top });
        }

        if (this.state.focus >= 0) {
          if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
          }
          this.timeoutId = setTimeout(() => {
            let rect = this.calculateBoundsFromRects(rects);
            rect.ready = true;
            this.setState({ selectionBounds: rect });
            this.setState({ menu: "edit" });
            this.clearSelection(false); // dont' clear focus
          }, 50);
        }
      });
    }, 50),

    _reindex(items) {
      let idx = 0;
      items.forEach(item => {
        item.id = idx++;
      });
    },

    _createAnnotation(params) {
      let annotation = {
        quote: this.state.rawRange.toString(),
        range: JSON.stringify(this.state.range),
        tag: params.tag || this.state.tag,
        tagid: params.tagid || 1,
        rects: [],
        id: this.state.annotations.count
      };

      let annotations = [...this.state.annotations, annotation];
      this._reindex(annotations);
      this.setState({ annotations: annotations });
      this.draw();
      this.clearSelection();

      this.onCreate(annotation);
    },

    _updateAnnotation(params) {
      //console.log(params);
      try {
        let annotation = this.state.annotations[params.id];
        let annotations = [...this.state.annotations];
        annotations.splice(params.id, 1);

        if (params.tag != undefined) {
          annotation.tag = params.tag;
          annotation.tagid = params.tagid;
        }

        if (params.comment != undefined) {
          annotation.comment = params.comment;
        }

        annotations.push(annotation);
        this._reindex(annotations);

        this.setState({ annotations: annotations });
        this.draw();
        this.clearSelection();

        this.onUpdate(annotation);
      } catch (e) {
        // why?
        console.log(e);
      }
    },

    digest(show) {
      var content = this.$lawyerly.annotations.digest({
        annotations: this.state.annotations
      });
      //console.log(content);
      this.setState({ digest: content });
    },

    annotation() {
      if (this.state.focus != null) {
        return this.state.annotations[this.state.focus];
      }
      return null;
    },

    annotate(params) {
      this.$store.commit("ui/setSpinner", true);
      this.debugLog(params);

      params = params || {};
      this.setState({ tag: params.tag || this.state.tag });
      
      if (this.state.selection) {
        this._createAnnotation(params);
      } else if (params.id != undefined) {
        this._updateAnnotation(params);
      }

      this.setState({ menu: null, subMenu: null });
    },

    comment(params) {
      this._updateAnnotation(params);
      var annot = this.annotation();
      if (annot) {
        if (!annot.comment) {
          this.$set(annot, "comment", params.comment);
        }
        annot.comment = params.comment;
      }
      this.setState({ menu: null, subMenu: null });
    },

    erase(idx) {
      try {
        let annotation = this.state.annotations[idx];
        let annotations = [...this.state.annotations];
        annotations.splice(idx, 1);
        this._reindex(annotations);
        this.setState({ annotations: annotations, menu: "" });
        this.draw();
        this.clearSelection();
        this.onDelete(annotation);
      } catch (e) {
        // why?
        //console.log(idx);
        console.log(e);
      }
    },

    eraseAll() {
      this.setState({ annotations: [], menu: "" });
      this.draw();
      this.clearSelection();
      this.onDelete("all");
    },

    clearSelection(clearFocus = true) {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        // IE?
        document.selection.empty();
      }

      this.setState({ selection: null });
      this.setState({ range: null });
      this.setState({ rawRange: null });

      if (clearFocus) {
        this.setState({ focus: null });
      }
    },

    calculateSelectionBounds: debounce(function(range) {
      if (range == null) return;

      if (this.$config.mobile) {
        this.setState({ ready: true });
        return;
      }

      try {
        let rect = this.calculateBoundsFromRects(range.getClientRects());
        rect.ready = true;
        this.setState({ selectionBounds: rect });
      } catch (e) {
        // this.debugLog(e);
      }
    }, 50),

    calculateBoundsFromRects: function(rects) {
      let rect = {};

      for (let clientRect of rects) {
        let x = clientRect.x || clientRect.left;
        let y = clientRect.y || clientRect.top;
        let x2 = x + (clientRect.width || 0);
        let y2 = y + (clientRect.height || 0);

        if (rect.x > x || !rect.x) {
          rect.x = x;
        }
        if (rect.y > y || !rect.y) {
          rect.y = y;
        }
        if (rect.x2 < x2 || !rect.x2) {
          rect.x2 = x2;
        }
        if (rect.y2 < y2 || !rect.y2) {
          rect.y2 = y2;
        }
      }

      rect.width = rect.x2 - rect.x;
      rect.height = rect.y2 - rect.y;
      rect.ready = true;

      rect.x = rect.x + window.scrollX;
      rect.y = rect.y + window.scrollY;
      return rect;
    },

    setZIndices() {
      let elm = this.root;
      let z = 1;
      while (elm && elm !== document.body) {
        if (!elm.style.zIndex) {
          elm.style.zIndex = z++;
        }
        elm = elm.parentElement;
      }
    },

    accountForOffsets: debounce(function() {
      try {
        let canvas = this.$refs["canvas"];
        let canvasRect = canvas.getBoundingClientRect();
        let rootRect = this.root.getBoundingClientRect();
        this.setState({
          offset: {
            x: rootRect.left - canvasRect.left,
            y: rootRect.top - canvasRect.top
          }
        });
      } catch (e) {
        // console.log()
      }
    }, 0),

    draw() {
      // TODO re-renders each time!?
      this.state.annotations.forEach(a => {
        this.drawAnnotation(a);
      });

      // first, position the canvas
      let canvasRect = this.root.getBoundingClientRect();
      let canvas = {};
      canvas.top = this.root.offsetTop;
      canvas.left = this.root.offsetLeft;
      canvas.width = canvasRect.width;
      canvas.height = canvasRect.height;

      if (this.state.offset == null) {
        this.accountForOffsets();
      }

      this.setState({ canvas: canvas });

      let rects = [];
      this.state.annotations.forEach(a => {
        a.rects.forEach(r => {
          if (!r) return; // why would this happen?
          rects.push({
            x: r.x - 2,
            y: r.y - 2,
            width: r.width,
            height: r.height,
            id: a.id,
            tag: a.tag
          });
        });
        // cleanup so rects doesn't get saved
        a.rects = null;
      });

      this.setState({ highlights: rects });

      this.setZIndices();
    },

    drawAnnotation(annotation) {
      annotation.rects = [];

      const _obj = JSON.parse(annotation.range);

      let obj = _obj;
      if(Array.isArray(obj)) {
        obj = _obj[0];
      };
      let range = null;
      try {
        range = toRange(
          obj.start,
          obj.startOffset,
          obj.end,
          obj.endOffset,
          this.$refs.root
        );

      } catch (e) {
        // document modified?
        console.log(e);
        // mark for removal?
        return;
      }

      let bound = this.root.getBoundingClientRect();

      // use X,Y
      bound.x = bound.x || bound.left;
      bound.y = bound.y || bound.top;

      annotation.y = 0;

      let rects = range.getClientRects();
      for (let i = 0; i < rects.length; i++) {
        let rect = rects.item(i);

        // use X,Y
        rect.x = rect.x || rect.left;
        rect.y = rect.y || rect.top;

        // make relative
        rect.y = rect.y - bound.y;
        rect.x = rect.x - bound.x;
        if (annotation.y === 0) {
          annotation.y = rect.y;
        }
        annotation.rects.push(rect);
      }
    },

    requestMenu(menu) {
      if (this.state.subMenu == menu) {
        menu = ""; // toggle
      }
      this.setState({ subMenu: menu });
    },

    openShareLink(event) {
      // event.preventDefault();
      // window.open(
      //   event.srcElement.href,
      //   "",
      //   "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
      // );
    },

    debugLog(text) {
      console.log(text);
    },

    self() {
      return this;
    },

    scrollTo(elm) {
      var cc = elm.closest("ion-content");
      cc.scrollToPoint(0, elm.offsetTop, 400);
    },

    onClick(evt) {
      var src = evt.srcElement;
      if (src.tagName === "SUP") {
        var sups = document.querySelectorAll("sup");
        for (var i = 0; i < sups.length; i++) {
          var s = sups.item(i);
          if (s === src) {
            continue;
          }
          if (s.innerText === src.innerText) {
            this.scrollTo(s);
            break;
          }
        }
      }
    },

    onSaveInterval() {
      if (this.requestUpload) {
        this.requestUpload = false;
        this.upload();
      }
    },

    copyText() {
      //get selected text
      var text = this.state.rawRange.toString();

      // copy to clipboard
      const cordova = window.cordova;
      if(cordova !== undefined) {
        cordova.plugins.clipboard.copy(text);
        this.$ionic.showToast("Text Copied.", {
          position: "bottom"
        });
      } else {
        navigator.clipboard.writeText(text);
         this.$ionic.showToast("Text Copied.", {
            position: "bottom"
          });
      }

      this.setState({ menu: null, subMenu: null });
      this.clearSelection();
    },

    addToNotebook() {
      const text = this.annotation();
      if(text) {
         this.$store.commit("ui/setText", text.quote);
      }
      this.$parent.$refs.popupmenu.bookmark();
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeoutId);
    clearInterval(this.saveIntervalId);
    this.onSaveInterval();
    EventSpy.stop();
  },

  mounted() {

    window.$art = this;

    this.attachEventSpy();
    setTimeout(this.onRead, 500);
    setInterval(this.onSaveInterval, 5000);

    this.$watch(() =>{ return this.state.annotations.length; }, ()=>{
     if(this.state.annotations.length > 0) {
        this.$store.commit("ui/ShowClearHighlights", true);
      } else {
        this.$store.commit("ui/ShowClearHighlights", false);
      }
    });

    try {
      // this.root.addEventListener('contextmenu', event => {
      //   console.log('fired');
      //     event.preventDefault();
      //   });
      var navigator = window.navigator;
      this.isMobile =
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i);
      if (!this.isMobile) {
        this.isMobile =
          document.querySelector("html").offsetWidth < 600
            ? "smallScreen"
            : null;
      }

      if(this.isMobile) {
        this.root.addEventListener('contextmenu', event => {
          event.preventDefault();
        });
      }

    } catch (e) {
      // what are we then?
    }
  },

  components: {
    "annot8-ui": Annot8UI,
    "annot8-canvas": Annot8Canvas
  }
};
</script>

<style lang="scss">
@import "./annot8.scss";
sup {
  color: red;
  cursor: pointer;
}
</style>
